import React, { useState } from "react"
import { injectIntl, FormattedMessage } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import Toggle from "react-toggle"
import Tooltip from "../../common/tooltip/Tooltip"

type OwnProps = {
    key: number
    syncItemsWithCatalogPrices: boolean
    onChange: (event: React.MouseEvent) => void
}

const SyncItemsWithCatalogPrices = (props: OwnProps & IntlProps) => {

    const [syncWithCatalogPrices, setSyncWithCatalogPrices] = useState<boolean>(props.syncItemsWithCatalogPrices)

    return (
        <div key={props.key} className="d-flex mt-1">            
            <Tooltip tooltipId="tooltip_sync_with_catalog_prices"
                message={
                    <FormattedMessage
                        id={"price-list.components.sync_items_with_catalog_prices.tooltip_message_sync_with_catalog_prices"}
                        defaultMessage={`If this option is enabled: {br}
                            Synchronize automatically all line items unit prices based on the prices
                            from the catalog once per day. {br} 
                            Manually editing the unit price on the pricing table lines won't be possible.`} 
                        values={{ br: <br /> }}
                    />
                }
            >
                <label className="mb-0 custom-form-label">
                    <FormattedMessage
                        id="price-list.components.sync_items_with_catalog_prices.label_message_sync_with_catalog_prices"
                        defaultMessage="Sync line items with catalog prices"
                    />
                </label>
            </Tooltip>                
            <div className="ml-2">
                <Toggle
                    id={"toggle_sync_with_catalog_prices"}
                    defaultChecked={syncWithCatalogPrices}
                    checked={syncWithCatalogPrices}
                    icons={false}
                    onChange={(event) => {
                        setSyncWithCatalogPrices(event.target.checked)
                        props.onChange(event)
                    }}
                />
            </div>
        </div>
    )
}

export default injectIntl(SyncItemsWithCatalogPrices)


// WEBPACK FOOTER //
// ./src/price-list/components/SyncItemsWithCatalogPrices.tsx